module.exports = __webpack_public_path__ + "files/96141cf6697d605131bf40936d418996.png";